export const amenities = [
  {
    type: 'air-conditioning',
    label: 'Air Conditioning',
    icon: 'air-conditioner.png',
  },
  { type: 'backyard', label: 'Backyard', icon: 'backyard.png' },
  { type: 'ceiling-fan', label: 'Ceiling Fan', icon: 'ceiling-fan.png' },
  { type: 'closet-space', label: 'Closet Space', icon: 'closet.png' },
  { type: 'furnished', label: 'Furnished', icon: 'furnished.png' },
  { type: 'dishwasher', label: 'Dishwasher', icon: 'dishwasher.png' },
  { type: 'dryer', label: 'Dryer', icon: 'drying-machine.png' },
  {
    type: 'entry-security',
    label: 'Entry Security',
    icon: 'entry-security.png',
  },
  { type: 'freezer', label: 'Freezer', icon: 'freezer.png' },
  { type: 'refrigerator', label: 'Refrigerator', icon: 'fridge.png' },
  { type: 'heater', label: 'Heater', icon: 'heater.png' },
  { type: 'oven', label: 'Oven', icon: 'oven.png' },
  { type: 'patio', label: 'Patio', icon: 'patio.png' },
  {
    type: 'security-system',
    label: 'Security System',
    icon: 'security-system.png',
  },
  { type: 'stove', label: 'Stove', icon: 'stove.png' },
  { type: 'pool-access', label: 'Swimming pool', icon: 'swimming-pool.png' },
  { type: 'washer', label: 'Washer', icon: 'washing-machine.png' },
  { type: 'tv', label: 'TV', icon: 'watch-tv.png' },
  { type: 'wifi', label: 'WiFi', icon: 'wifi.png' },
] as const;

export const amenityIcons = Object.fromEntries(amenities.map(({ type, icon }) => [type, icon]));
